"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDeck = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shadows = require("../../system/shadows.style");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  padding: 0;\n  ", "\n  @media screen and (min-width: ", ") {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledDeck = _styledComponents.default.ul(_templateObject(), function (props) {
  return props.width;
}, function (props) {
  return (0, _shadows.shadowStyle)(props.theme, props.shadow);
}, function (props) {
  return props.theme.breakpoints && props.theme.breakpoints.sm;
});

exports.StyledDeck = StyledDeck;